module.exports = __webpack_public_path__ + "3d79fd61513de78ce602b8c2cd50a633.jpg";